export default __webpack_public_path__ + "static/media/oil.f733dc21.jpg";